<template>
  <div class="grid mb-10 bg-white">
    <div class="grid-title">
      <h4>{{ title }}</h4>
    </div>
    <div class="grid-body">
      <div
        class="grid p-10 mb-10"
        :key="info.id"
        v-for="(info, index) in localNotes"
      >
        <label class="text-capitalize text-bold">
          {{ info.user.first_name }} {{ info.user.last_name }} wrote:
        </label>
        <p>{{ info.notes }}</p>
        <span class="badge badge-info">
          {{ dateFormat(info.updated_at) ? dateFormat(info.updated_at) : dateFormat(info.created_at) }}
        </span>
        <span
          class="badge badge-warning pointer"
          @click="editNote(index)"
          v-if="currentUser.id === info.user.id"
        >
          Edit
        </span>
        <span
          class="badge badge-danger pointer"
          @click="deleteNote(index)"
          v-if="currentUser.role === 'admin'"
        >
          Delete
        </span>
      </div>

      <label>New Note</label>
      <textarea
        class="form-control"
        v-model="newNote"
        rows="6"
        placeholder="Write New Note"
      ></textarea>
      <br />
      <button
        class="btn btn-success btn-block"
        @click="createNote"
        v-if="!isReadOnlyUser"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import toastr from "toastr";

export default {
  props: {
    notes: {
      type: Array,
      required: true,
    },
    orderNumber: {
      required: true,
    },
    isReadOnlyUser: {
      type: Boolean,
      default: false,
    },
    createRoute: {
      type: String,
      required: true,
    },
    updateRoute: {
      type: String,
      required: true,
    },
    deleteRoute: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Order Notes",
    },
    orderType: {
      type: String,
      required: true,
    },
    currentUser: {
      required: true,
    }
  },
  data() {
    return {
      localNotes: [...this.notes],
      newNote: null,
    };
  },
  watch: {
    notes(newNotes) {
      this.localNotes = [...newNotes]; // Watch for changes in the prop and update localNotes
    },
  },
  methods: {
    async createNote() {
      try {
        let res = await axios.post(this.createRoute, {
          [`${this.orderType}_order_id`]: this.orderNumber,
          notes: this.newNote,
        });
        this.localNotes.push(res.data);
        this.newNote = null;
        this.$emit("update:notes", this.localNotes);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }
    },

    async deleteNote(index) {
      let result = await Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });
      if (result.value) {
        let data = this.localNotes[index];
        try {
          let res = await axios.delete(`${this.deleteRoute}/${data.id}`);
          if (res) {
            this.localNotes.splice(index, 1);
            this.$emit("update:notes", this.localNotes);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          }
        }
      }
    },

    async editNote(index) {
      let note = this.localNotes[index];
      const { value: updatedNote } = await Swal.fire({
        title: "Edit order note",
        input: "text",
        inputValue: note.notes,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'You need to write something!';
          }
          return null;
        }
      });

      if (updatedNote) {
        try {
          let res = await axios.put(`${this.updateRoute}/${note.id}`, {
            notes: updatedNote,
          });
          if (res) {
            this.localNotes[index].notes = updatedNote;
            this.localNotes[index].updated_at = res.data.updated_at;

            this.$emit("update:notes", this.localNotes);
          }
        } catch (error) {
          if (error.response && error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error("An error occurred while trying to delete the note.");
          }
        }
      }
    },

    dateFormat(date, format = "MMM DD, YYYY HH:mm:ss") {
      return moment(date).utc().format(format);
    },
  },
};
</script>
<style scoped>
.grid-title h4 {
  text-overflow: unset !important;
  width: 100% !important;
}
h4 {
  font-weight: bold !important;
}
.grid-title {
  border-top: 1px solid #eee;
}
</style>
